import styled from "styled-components";

export const SecondorieContainer = styled.div`
    max-width: 1100px;
    width: 100%;
    margin: 60px auto 40px;
    padding: 0 var(--container-pad);

    @media (max-width: 600px) {
        margin-top: 40px;
    }
`;

export const SecondorieWrapper = styled.div`
    margin: 30px 0;
`;

export const MainText = styled.p`
    font-size: 17px;
    line-height: 1.65;
    font-weight: 400;
    color: var(--color-text);
    margin: 8px 0;

    a {
        text-decoration: none;
        color: var(--color-primary);
        font-weight: 600;
        border-bottom: 1px solid transparent;
        transition: var(--transition);

        &:hover {
            border-color: var(--color-primary);
        }
    }
`;

export const MainSmall = styled.p`
    font-size: 15px;
    line-height: 1.6;
    font-weight: 400;
    color: var(--color-text);
    margin: 8px 0;
`;

export const HeadText = styled.p`
    text-align: center;
    line-height: 1.2;
    font-size: clamp(26px, 3.4vw, 36px);
    font-weight: 800;
    color: var(--color-primary);
    letter-spacing: -0.5px;
    margin: 0 0 24px;
`;

export const FirstContainer = styled.div`
    margin-top: 28px;
    width: 100%;
`;

export const SecondHeadText = styled.p`
    font-size: 18px;
    font-weight: 700;
    color: var(--color-primary);
    margin: 0 0 8px;
`;

export const TeacherBlock = styled.div`
    background: var(--color-bg-soft);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-xl);
    width: 100%;
    box-shadow: var(--shadow-sm);
    overflow: hidden;
`;

export const TeacherBlockHight = styled.div`
    display: grid;
    grid-template-columns: 240px 1fr;
    gap: 24px;
    padding: 28px 28px 12px;
    align-items: center;

    @media (max-width: 700px) {
        grid-template-columns: 1fr;
        text-align: center;
        padding: 24px 22px 8px;
    }
`;

export const TeacherBlockBottom = styled.div`
    padding: 0 28px 28px;

    @media (max-width: 700px) {
        padding: 0 22px 22px;
    }
`;

export const CircleBlock = styled.img`
    width: 200px;
    height: 200px;
    border-radius: 50%;
    object-fit: cover;
    box-shadow: var(--shadow-md);
    margin: 0 auto;
    display: block;
`;

export const TeacherBlocksHight = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;
